// extracted by mini-css-extract-plugin
module.exports = {"main":"Item_main__3RbRq","side":"Item_side__iuln8","spb":"Item_spb__iBEjk"};